import { Button } from '@cbhq/cds-web/buttons';
import { Fallback } from '@cbhq/cds-web/layout/Fallback';

import { useSimpleBreakpoints } from ':cloud/hooks/useSimpleBreakpoints';
import { SubscriptionState } from ':cloud/hooks/useSubscriptionState';
import { PaymentMethod } from ':cloud/types/service_proto';
import { PaymentMethodDisplayer } from ':cloud/widgets/billing/PaymentMethodDisplayer';

interface PaymentMethodCellProps {
  paymentMethod?: PaymentMethod;
  subscriptionState: SubscriptionState;
  onReplacePaymentMethod: () => void;
  onReactivate: () => void;
  isLoading: boolean;
}
function PaymentMethodCell({
  paymentMethod,
  subscriptionState,
  onReplacePaymentMethod,
  onReactivate,
  isLoading,
}: PaymentMethodCellProps) {
  const { status } = subscriptionState;
  const isSubscriptionInactive = status === 'canceled' || status === 'trial-expired';
  const { isPhone } = useSimpleBreakpoints();

  if (isLoading) {
    return <Fallback width={150} height={40} shape="squircle" />;
  }

  if (isSubscriptionInactive) {
    return (
      <Button block onPress={onReactivate}>
        Reactivate
      </Button>
    );
  }

  if (paymentMethod) {
    return (
      <PaymentMethodDisplayer
        paymentMethod={paymentMethod}
        spacingHorizontal={0}
        transparent
        showIcon={!isPhone}
      />
    );
  }
  return (
    <Button block onPress={onReplacePaymentMethod}>
      Add a payment method
    </Button>
  );
}

export default PaymentMethodCell;
